import { html, when } from '@microsoft/fast-element';
import { getPrefix } from '../utils/dom';
export const getPrefixedFlyout = (prefix) => html `
  <div ?closed=${(x) => x.closed} ?visuallyhidden=${(x) => x.visuallyhidden}>
    <div class="container">
      <div class="background" part="background" @click=${(x) => x.closeFlyout()}></div>
      <div class="flyout" part="flyout" @transitionend=${(x) => x.closingFinished()}>
        ${when((x) => x.displayHeader, html `
            <div class="header" part="header">
              <div class="title" part="title">
                <slot name="title"></slot>
              </div>
              <div class="exit" part="exit" @click=${(x) => x.closeFlyout()}>
                <${prefix}-icon name="times"></${prefix}-icon>
              </div>
            </div>
          `)}
        <div class="content" part="content">
          <slot></slot>
        </div>
        <div class="footer" part="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
`;
export const foundationFlyoutTemplate = html `
  ${(x) => getPrefixedFlyout(getPrefix(x))}
`;
